export const isTimestampEligibleForPolling = (
	timestamp: string,
	threshold: number
) => {
	return new Date().getTime() - new Date(timestamp).getTime() < threshold;
};
